import { cn } from '@/lib/cn';

export type SeverityLevel = 'LOW' | 'MEDIUM' | 'HIGH' | 'CRITICAL';
export type SkuStatus =
  | 'STOCKOUT'
  | 'CRITICAL'
  | 'LOW'
  | 'OPTIMAL'
  | 'EXCESS'
  | 'DEAD_STOCK'
  | 'NORMAL'
  | 'STAR'
  | 'CASH_COW'
  | 'QUESTION_MARK'
  | 'DOG';

const SEVERITY_STYLES: Record<SeverityLevel, { cls: string; label: string }> = {
  LOW: { cls: 'bg-secondary text-black', label: 'LOW' },
  MEDIUM: { cls: 'bg-warning text-black', label: 'MEDIUM' },
  HIGH: { cls: 'bg-primary text-black', label: 'HIGH' },
  CRITICAL: { cls: 'bg-error text-white', label: 'CRITICAL' },
};

const SKU_STYLES: Record<SkuStatus, { cls: string; label: string }> = {
  STOCKOUT: { cls: 'bg-error text-white', label: 'STOCKOUT' },
  CRITICAL: { cls: 'bg-error text-white', label: 'CRITICAL' },
  LOW: { cls: 'bg-warning text-black', label: 'LOW' },
  OPTIMAL: { cls: 'bg-tertiary text-black', label: 'OPTIMAL' },
  EXCESS: { cls: 'bg-secondary text-black', label: 'EXCESS' },
  DEAD_STOCK: { cls: 'bg-outline text-text-bright', label: 'DEAD' },
  NORMAL: { cls: 'bg-outline text-text-bright', label: 'NORMAL' },
  STAR: { cls: 'bg-primary text-black', label: 'STAR' },
  CASH_COW: { cls: 'bg-tertiary text-black', label: 'CASH_COW' },
  QUESTION_MARK: { cls: 'bg-warning text-black', label: 'Q?' },
  DOG: { cls: 'bg-outline text-text-muted', label: 'DOG' },
};

export function StatusBadge({ severity }: { severity: SeverityLevel }) {
  const style = SEVERITY_STYLES[severity];
  return (
    <span
      className={cn(
        'inline-flex items-center gap-1 px-2.5 py-1 font-bold uppercase tracking-widest text-[10px]',
        'border-2 border-black',
        style.cls,
      )}
    >
      {style.label}
    </span>
  );
}

export function SkuStatusBadge({ status }: { status: SkuStatus }) {
  const style = SKU_STYLES[status];
  return (
    <span
      className={cn(
        'inline-flex items-center px-2.5 py-1 font-bold uppercase tracking-widest text-[10px]',
        'border-2 border-black',
        style.cls,
      )}
    >
      {style.label}
    </span>
  );
}
